<template>
  <div
    :class="{'active': checked}"
    class="radio-input"
    @click="click">
    <i class="far fa-circle firstCircle"/>
    <i class="fas fa-circle secondCircle"/>
    <input
      :value="value"
      type="radio"
      class="d-none">
  </div>
</template>

<script>
export default {
  name: 'RadioInput',
  components: {},
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    click() {
      this.$emit('input', this.value);
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.radio-input {
    cursor: pointer;
    display: flex;
    position: relative;
    color: $primary;
    &.active {
      color: $primary;
    }
    &:hover {
      &:not(.active) {
        i {
          &.secondCircle {
            display: block !important;
            opacity: 0.7;
          }
        }
      }
    }
  }
  &.active {
    i {
      &.secondCircle {
        display: block !important;
      }
    }
  }
}
i {
  &.firstCircle {
    font-size: 30.7px;
  }
  &.secondCircle {
    display: none;
    position: absolute;
    top: 6.5px;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 17px;
  }
}
</style>
